import script from "./VentilatorItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VentilatorItem.vue?vue&type=script&setup=true&lang=js"

import "./VentilatorItem.vue?vue&type=style&index=0&id=177fc070&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177fc070"]])

export default __exports__